import { createContext, useContext, useEffect, useState } from "react";
import { adminHttp } from "@/lib/api";

const AdminAuthCtx = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = authed
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("azefac_admin_token");
    if (!t) {
      setUser(false);
      setLoading(false);
      return;
    }
    adminHttp
      .get("/admin/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await adminHttp.post("/admin/login", { email, password });
    localStorage.setItem("azefac_admin_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("azefac_admin_token");
    setUser(false);
  };

  return (
    <AdminAuthCtx.Provider value={{ user, loading, login, logout }}>
      {children}
    </AdminAuthCtx.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthCtx);
